<template>
<div class="email-input-container">
    <div class="tag-container">
      <div class="tag" v-for="tag in tags" :key="tag.id" closable>
        <div class="name">{{ tag.memberName }}</div>
        <div
          class="close"
          @click="handleClose(tag)"
          @mouseover="hoverTag = tag"
          @mouseleave="hoverTag = null"
        >
          <svg-icon :icon-class="email_tag_close(tag)" />
        </div>
      </div>
    </div>
    <div class="input-container">
      <moo-input
        v-model="userName"
        :placeholder="placeholderStr"
        class="input-title"
        @input="inputChange"
        @blur="blur"
        ref="input"
      ></moo-input>
      <div
        v-if="isShowUserSearchList"
        class="searchList"
        id="searchFilterSearchUserList"
        ref="searchListRef"
      >
        <div
          class="searchItemContainer"
          v-for="(item, index) in userSearchList"
          :key="index"
          @click="selectUser(item)"
        >
          <div class="searchItem">
            <div class="searchIcon"><img :src="item.memberAvatar" /></div>
            <div class="userInfo">
              <div class="userName">{{ item.memberName }}</div>
              <div class="userPartment">{{ item.departmentName }}</div>
            </div>
          </div>
        </div>
        <div
          class="search-scrollbar"
          :class="{ hide: !showScrollbar }"
          ref="scrollbarRef"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { searchMember } from "@/api/h5/file";
import { debounce } from "@/utils/lodash";

export default {
  name: "test_vue",
  props: {
    placeholder: {
      type: String,
      default() {
        return "";
      },
    },
  },
  emits: [],
  components: {},
  data() {
    return {
      hoverTag: null,
      userName: "",
      tags: [],
      isShowUserSearchList: false,
      userSearchList: [],
      showScrollbar: false,
      hideScrollbarTimer: null,
    };
  },
  watch: {
    isShowUserSearchList(v) {
      if (v === true) {
        setTimeout(() => {
          const userListEL = document.getElementById(
            "searchFilterSearchUserList"
          );
          if (userListEL) {
            userListEL.addEventListener("scroll", this.onListScroll);
          }
        }, 200);
      } else {
        setTimeout(() => {
          const userListEL = document.getElementById(
            "searchFilterSearchUserList"
          );
          if (userListEL) {
            userListEL.removeEventListener("scroll", this.onListScroll);
          }
        }, 200);
      }
    },
  },
  computed: {
    placeholderStr() {
      return this.tags.length > 0 ? "" : this.placeholder;
    },
  },
  methods: {
    getAllTags() {
      return JSON.parse(JSON.stringify(this.tags));
    },
    email_tag_close(tag) {
      if (this.hoverTag !== null && this.hoverTag.id === tag.id) {
        return "email_tag_close_hover";
      }
      return "email_tag_close";
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
    },
    inputChange(value) {
      this.startSearchUser(value);
    },
    blur() {
      setTimeout(() => {
        this.userName = "";
        this.isShowUserSearchList = false;
        this.userSearchList = [];
      }, 200);
    },
    startSearchUser(userName) {
      const searchText = userName;
      if (searchText === "") {
        this.isShowUserSearchList = false;
      }
      this.reqSearchUser(searchText);
    },
    reqSearchUser: debounce(async function(searchText) {
      if (searchText === "") {
        this.userSearchList = [];
        return;
      }
      //触发搜索
      try {
        let res = null;
        res = await searchMember(searchText, true);
        const { code, data } = res || {};
        if (code == 200) {
          const { searchKey, members } = data;
          this.userSearchList = [];
          for (let i = 0; i < members.length; i++) {
            let item = members[i];
            const userAvatar = JSON.parse(item.memberAvatar)["100"];
            item.memberAvatar = userAvatar;
            item.departmentName = "";
            if (item.departments && item.departments.length > 0) {
              for (let j = 0; j < item.departments.length; j++) {
                if (j == item.departments.length - 1) {
                  item.departmentName += item.departments[j].departmentName;
                } else {
                  item.departmentName +=
                    item.departments[j].departmentName + "/";
                }
              }
            }
            this.userSearchList.push(item);
          }
        }
        if (this.userSearchList.length > 0) {
          this.isShowUserSearchList = true;
        }
      } catch (error) {
        console.log("-------------------error:", error);
        this.userSearchList = [];
      }
    }, 300),
    selectUser(user) {
      this.userName = "";
      console.log("-----------------------tas:", this.tags, user);
      this.tags = this.tags.filter((item) => item.id !== user.id);
      this.tags.push(user);
      this.userSearchList = [];
      this.isShowUserSearchList = false;
      this.$refs.input.focus();
    },
    //滚动条
    onListScroll() {
      console.log("----------------------onListScroll");
      const listEl = document.getElementById("searchFilterSearchUserList");
      if (!listEl) return;
      const scrollbarEl = this.$refs.scrollbarRef;

      const scrollTop = listEl.scrollTop;
      const scrollHeight = listEl.scrollHeight;
      const clientHeight = listEl.clientHeight;
      const scrollbarHeight = (clientHeight * clientHeight) / scrollHeight;
      const scrollbarTop = (scrollTop * clientHeight) / scrollHeight;

      scrollbarEl.style.height = `${scrollbarHeight}px`;
      scrollbarEl.style.top = `${scrollTop + scrollbarTop}px`;

      this.showScrollbar = true;
      clearTimeout(this.hideScrollbarTimer);
      this.hideScrollbarTimer = setTimeout(() => {
        this.showScrollbar = false;
      }, 1000);
    },
  },
  beforeDestroy() {
    if (this.hideScrollbarTimer) {
      clearTimeout(this.hideScrollbarTimer);
      this.hideScrollbarTimer = null;
    }
  },
  mounted() {
    this.tags = [];
  },
};
</script>

<style lang="scss" scoped>
.email-input-container {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e8e9ee;
  border-radius: 4px;
  padding: 4px 12px;

  .user-container {
    width: 100%;
    height: 100%;
  }

  .tag-container {
    display: flex;
    max-width: 100%;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    .tag {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      height: 22px;
      background: #f4f6f9;
      border-radius: 4px;
      margin-right: 4px;
      margin-bottom: 2px;
      .name {
        margin-left: 8px;
        margin-right: 4px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #222329;
      }
      .close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 10px;
        height: 10px;
        margin-right: 8px;
      }
    }
  }
  .input-container {
    flex: 1;
    min-width: 60px;
    position: relative;
    line-height: 22px;
    .input-title {
      flex: 1;
      min-width: 60px;
    }

    .searchList {
      position: absolute;
      z-index: 2;
      width: 242px;
      top: 40px;
      left: 0px;
      right: 0px;
      padding: 4px 4px 0px 4px;
      max-height: 260px;
      overflow-y: auto;
      background-color: #fff;
      border-radius: 8px;
      border: 1px solid #e6e8ec;
      box-shadow: 0 8px 12px 0 #1213171a;

      &::-webkit-scrollbar {
        display: none;
      }

      .searchItemContainer {
        height: 49px;
        cursor: pointer;

        .searchItem:hover {
          background-color: #f4f6f9;
        }

        .searchItem {
          height: 45px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          .searchIcon {
            width: 37px;
            height: 37px;
            margin: 0px 8px;
            background-color: #f4f6f9;
            img {
              width: 37px;
              height: 37px;
              border-radius: 8px;
            }
          }
          .userInfo {
            display: flex;
            flex-direction: column;
            align-items: start;
            padding: 4px 0px;
            .userName {
              text-align: left;
              width: 185px;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              color: #323233;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .userPartment {
              text-align: left;
              width: 185px;
              color: #a2a4b0;
              font-size: 12px;
              font-weight: 400;
              line-height: 17px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      //滚动条
      .search-scrollbar {
        position: absolute;
        right: 4px;
        top: 0;
        width: 4px;
        background-color: #dcddde;
        border-radius: 3px;
        transition: opacity 0.2s ease-in-out;

        &.hide {
          opacity: 0;
        }
      }

      .noSearchResult {
        height: 37px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #323233;
      }
    }
  }
}
</style>

<style lang="scss">
.email-input-container {
  .input-title {
    height: 22px;
    line-height: 22px;
    box-sizing: border-box;
    background: #ffffff;
    .moo-input__inner {
      height: 22px;
      line-height: 22px;
      color: #222329 !important;
      line-height: 22px !important;
      border: none !important;
      caret-color: #5c70ff;
      padding: 0px;
    }
  }
}
</style>
